module.exports = __webpack_public_path__ + "img/SILHOUETTE_PAI.a8c13c64.svg";